export const types = {


  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_REQUEST_SUCCESS: 'LOGIN_REQUEST_SUCCESS',
  LOGIN_REQUEST_ERROR: 'LOGIN_REQUEST_ERROR',

  USER_RESET_PROPS: 'USER_RESET_PROPS',

  GET_INSTRUCTION_REQUEST: 'GET_INSTRUCTION_REQUEST',
  GET_INSTRUCTION_ERROR: 'GET_INSTRUCTION_ERROR',
  GET_INSTRUCTION_SUCCESS: 'GET_INSTRUCTION_SUCCESS',

  GET_PROFILE_REQUEST: 'GET_PROFILE_REQUEST',
  GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
  GET_PROFILE_ERROR: 'GET_PROFILE_ERROR',

  GET_CUSTOMER_IDENTITY_INFO_REQUEST: 'GET_CUSTOMER_IDENTITY_INFO_REQUEST',
  GET_CUSTOMER_IDENTITY_INFO_SUCCESS: 'GET_CUSTOMER_IDENTITY_INFO_SUCCESS',
  GET_CUSTOMER_IDENTITY_INFO_ERROR: 'GET_CUSTOMER_IDENTITY_INFO_ERROR',


  GET_CALL_HISTORY_BY_NUMBER_REQUEST: 'GET_CALL_HISTORY_BY_NUMBER_REQUEST',
  GET_CALL_HISTORY_BY_NUMBER_SUCCESS: 'GET_CALL_HISTORY_BY_NUMBER_SUCCESS',
  GET_CALL_HISTORY_BY_NUMBER_ERROR: 'GET_CALL_HISTORY_BY_NUMBER_ERROR',


  GET_CALL_HISTORY_BY_EXTENSION_REQUEST: 'GET_CALL_HISTORY_BY_EXTENSION_REQUEST',
  GET_CALL_HISTORY_BY_EXTENSION_SUCCESS: 'GET_CALL_HISTORY_BY_EXTENSION_SUCCESS',
  GET_CALL_HISTORY_BY_EXTENSION_ERROR: 'GET_CALL_HISTORY_BY_EXTENSION_ERROR',

  GET_CALL_INSTRuCTION_REQUEST: 'GET_CALL_INSTRuCTION_REQUEST',
  GET_CALL_INSTRuCTION_SUCCESS: 'GET_CALL_INSTRuCTION_SUCCESS',
  GET_CALL_INSTRuCTION_ERROR: 'GET_CALL_INSTRuCTION_ERROR',


  GET_CALL_CUSTOMER_INFO_REQUEST: 'GET_CALL_CUSTOMER_INFO_REQUEST',
  GET_CALL_CUSTOMER_INFO_SUCCESS: 'GET_CALL_CUSTOMER_INFO_SUCCESS',
  GET_CALL_CUSTOMER_INFO_ERROR: 'GET_CALL_CUSTOMER_INFO_ERROR',


  GET_INSTRUCTION_LIST_REQUEST: 'GET_INSTRUCTION_LIST_REQUEST',
  GET_INSTRUCTION_LIST_SUCCESS: 'GET_INSTRUCTION_LIST_SUCCESS',
  GET_INSTRUCTION_LIST_ERROR: 'GET_INSTRUCTION_LIST_ERROR',

  GET_PROFILE_RESET_PROPS: 'GET_PROFILE_RESET_PROPS',
  GET_REPORT_RESET_PROPS: 'GET_REPORT_RESET_PROPS',

  SET_INSTRUCTION_DATA_OBJECT: 'SET_INSTRUCTION_DATA_OBJECT',
  INSTRUCTION_RESET_PROPS: 'INSTRUCTION_RESET_PROPS',
  SET_INSTRUCTION_PAGE_POSITION: 'SET_INSTRUCTION_PAGE_POSITION',
  SET_INSTRUCTION_DISPLAY_DATALIST: 'SET_INSTRUCTION_DISPLAY_DATALIST',


  GE_ATTACHMENT_LINK_REQUEST: 'GE_ATTACHMENT_LINK_REQUEST',
  GE_ATTACHMENT_LINK_SUCCESS: 'GE_ATTACHMENT_LINK_SUCCESS',
  GE_ATTACHMENT_LINK_ERROR: 'GE_ATTACHMENT_LINK_ERROR',
  SET_USER_ONLINE_REQUEST: 'SET_USER_ONLINE_REQUEST',
  SET_USER_ONLINE_SUCCESS: 'SET_USER_ONLINE_SUCCESS',
  SET_USER_ONLINE_ERROR: 'SET_USER_ONLINE_ERROR',


  SET_USER_OFFLINE_REQUEST: 'SET_USER_OFFLINE_REQUEST',
  SET_USER_OFFLINE_SUCCESS: 'SET_USER_OFFLINE_SUCCESS',
  SET_USER_OFFLINE_ERROR: 'SET_USER_OFFLINE_ERROR',


  GET_CALL_REPORT_BY_ID_REQUEST: 'GET_CALL_REPORT_BY_ID_REQUEST',
  GET_CALL_REPORT_BY_ID_SUCCESS: 'GET_CALL_REPORT_BY_ID_SUCCESS',
  GET_CALL_REPORT_BY_ID_ERROR: 'GET_CALL_REPORT_BY_ID_ERROR',



  SAVE_CALL_REPORT_REQUEST: 'SAVE_CALL_REPORT_REQUEST',
  SAVE_CALL_REPORT_SUCCESS: 'SAVE_CALL_REPORT_SUCCESS',
  SAVE_CALL_REPORT_ERROR: 'SAVE_CALL_REPORT_ERROR',




  UPDATE_CALL_REPORT_REQUEST: 'UPDATE_CALL_REPORT_REQUEST',
  UPDATE_CALL_REPORT_SUCCESS: 'UPDATE_CALL_REPORT_SUCCESS',
  UPDATE_CALL_REPORT_ERROR: 'UPDATE_CALL_REPORT_ERROR',


  GET_LOGIN_AS_REQUEST: 'GET_LOGIN_AS_REQUEST',
  GET_LOGIN_AS_SUCCESS: 'GET_LOGIN_AS_SUCCESS',
  GET_LOGIN_AS_ERROR: 'GET_LOGIN_AS_ERROR',

  SET_ONLINE_STATUS: 'SET_ONLINE_STATUS',
  SET_CALL_BOX_STATUS: 'SET_CALL_BOX_STATUS',
  SET_CALL_TRANSFER_STATUS: 'SET_CALL_TRANSFER_STATUS',


  GET_ALL_OPERATORS_REQUEST: 'GET_ALL_OPERATORS_REQUEST',
  GET_ALL_OPERATORS_SUCCESS: 'GET_ALL_OPERATORS_SUCCESS',
  GET_ALL_OPERATORS_ERROR: 'GET_ALL_OPERATORS_ERROR',






}
